/**************************************************
 * Nombre:       Tarjeta_Testimonios
 * Descripcion:
 *
 * Libreria:
 *
 * Tiempo:     5 Hr
 **************************************************/
import {Avatar, Grid, Typography} from "@mui/material";
import tmp_testi from '../../Recursos/tmp_testi.png'

const Tarjeta_Testimonios = ({item}) => {

    return (
        <Grid
            container
            justifyContent={'flex-start'}
            alignItems={'flex-start'}
            size={{xs: 12, sm: 12, md: 12}}
            sx={{
                background: 'rgba(255, 255, 255, 0.10)',
                backdropfilter: 'blur(2px)',
                p: 4,
                color: '#fff'
            }}
        >

            <Grid container size={{xs: 12, sm: 12, md: 12}} sx={{justifyContent: 'center'}}>
                <Avatar src={item.img} sx={{width: 60, height: 60}}/>
            </Grid>

            <Grid container size={{xs: 12, sm: 12, md: 12}} sx={{justifyContent: 'center'}}>
                <Typography sx={{fontSize: 24, fontWeight: 800}}>{item.nombre}</Typography>
            </Grid>

            <Grid container size={{xs: 12, sm: 12, md: 12}} sx={{justifyContent: 'center'}}>
                <Typography sx={{fontSize: 16, fontWeight: 400}}>{item.lugar}</Typography>
            </Grid>

            <Grid container size={{xs: 12, sm: 12, md: 12}} sx={{justifyContent: 'center', mt: 2}}>
                <Typography sx={{fontSize: 16, fontWeight: 400, textAlign: 'center'}}>
                    {item.descripcion}
                </Typography>
            </Grid>

        </Grid>
    )

}
export default Tarjeta_Testimonios    